import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";

const Field = ({
  inline,
  customClass = "",
  inlineBoxed,
  inlineRight,
  input = {},
  meta = {},
  field = "input",
  hideError = false,
  ...props
}) => {
  const prefixCls = "field";

  const {
    className,
    id,
    label,
    description,
    required,
    name,
    color,
    newUIFlag,
    ...inputProps
  } = props;
  /*eslint-disable no-nested-ternary */
  const variant = inline
    ? "inline"
    : inlineRight
    ? "inline-right"
    : inlineBoxed
    ? "inline-boxed"
    : null;
  /*eslint-enable no-nested-ternary */

  const componentCls = classnames(
    prefixCls,
    {
      [`${prefixCls}--error`]: meta.touched && meta.error,
      [`${prefixCls}--valid`]: meta.touched && meta.valid,
      [`${prefixCls}--${variant}`]: variant,
    },
    className
  );

  const labelCls = `${prefixCls}__label`;
  const controlCls = classnames(`${prefixCls}__control`, {
    [`${prefixCls}__control--error`]: meta.touched && meta.error,
  });
  const errorCls = `${prefixCls}__error`;
  const asteriskCls = newUIFlag ? `${prefixCls}__asterisk-pp` : `${prefixCls}__asterisk`;
  const descriptionCls = `${prefixCls}__description`;

  const isError = meta.touched && meta.error;
  const htmlFor = name || id;

  const fragments = {
    label: label ? (
      <label
        className={labelCls}
        htmlFor={htmlFor}
        style={{ backgroundColor: color, color: color && color !== "#FFFF00" && "white" }}
      >
        {required && (
          <span aria-label="Required" className={asteriskCls}>
            *
          </span>
        )}
        {label}
      </label>
    ) : null,
    description: description ? <div className={descriptionCls}>{description}</div> : null,
    control: React.createElement(field, {
      ...input,
      ...inputProps,
      color: color,
      id: htmlFor,
      error: isError,
      meta,
      className: `${controlCls} ${customClass}`,
      flat: inlineBoxed,
    }),
    error: <div className={errorCls}>{isError && meta.error}</div>,
  };

  if (inlineBoxed) {
    return (
      <div className={`${componentCls} year-selector`}>
        <div className={`${prefixCls}__label-wrapper`}>
          <strong>{fragments.label}</strong>
        </div>
        <div className={`${prefixCls}__control-wrapper`}>{fragments.control}</div>
      </div>
    );
  }

  return (
    <div className={componentCls}>
      <div className={`${prefixCls}__label-wrapper`}>
        <strong>{fragments.label}</strong>
        {fragments.description}
      </div>
      <div
        className={newUIFlag ? `${prefixCls}__control-wrapper-pp` : `${prefixCls}__control-wrapper`}
      >
        {fragments.control}
        {isError && !hideError && fragments.error}
      </div>
    </div>
  );
};

Field.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  inline: PropTypes.bool,
  inlineRight: PropTypes.bool,
  inlineBoxed: PropTypes.bool,
  input: PropTypes.object,
  meta: PropTypes.object,
  hideError: PropTypes.bool,
  field: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

export default Field;



// WEBPACK FOOTER //
// ./casper/sass/components/field/field.js